import { api } from "../AxiosInstance";
import { urlQueryBuilder } from "../utils/urlQueryBuilder";

// Interface for movement report request parameters
interface MovementReportParams {
  from?: number;
  to?: number;
  limit?: number;
  search?: string;
  skip?: number;
  transporterIds?: string;
}

// Interface for movement report response (based on actual API response)
export interface MovementReportData {
  message: string;
  error: boolean;
  data: {
    content: any[];
    links: Array<{
      rel: string;
      href: string;
    }>;
    page: {
      size: number;
      totalElements: number;
      totalPages: number;
      number: number;
    };
  };
}

const ReportService = {
  getMovementReport: async (
    params: MovementReportParams = {}
  ): Promise<MovementReportData> => {
    try {
      console.log(
        "ReportService.getMovementReport called with params:",
        params
      );

      // Build query string from parameters
      const queryString = urlQueryBuilder(params);
      const url = `/fed/movement-report${queryString ? `?${queryString}` : ""}`;

      console.log("Making API call to:", url);

      const response = await api.get(url);

      console.log("Movement Report API Response:", response.data);

      return response.data;
    } catch (error) {
      console.error("Error fetching movement report:", error);
      throw error;
    }
  },

  // Placeholder for other report-related API calls (commented out - APIs not yet available)

  // getBasicDailyMovementReport: async (params: MovementReportParams = {}): Promise<any> => {
  //   try {
  //     // This can be implemented when the API endpoint is available
  //     console.log("getBasicDailyMovementReport called with params:", params);
  //
  //     // For now, return empty data
  //     return {
  //       data: [],
  //       total: 0,
  //       page: 1,
  //       size: 10
  //     };
  //   } catch (error) {
  //     console.error("Error fetching basic daily movement report:", error);
  //     throw error;
  //   }
  // },

  // getAdvancedDailyMovementReport: async (params: MovementReportParams = {}): Promise<any> => {
  //   try {
  //     // This can be implemented when the API endpoint is available
  //     console.log("getAdvancedDailyMovementReport called with params:", params);
  //
  //     // For now, return empty data
  //     return {
  //       data: [],
  //       total: 0,
  //       page: 1,
  //       size: 10
  //     };
  //   } catch (error) {
  //     console.error("Error fetching advanced daily movement report:", error);
  //     throw error;
  //   }
  // },

  // downloadMovementReport: async (params: MovementReportParams = {}): Promise<{ downloadUrl: string; expiresAt: number }> => {
  //   try {
  //     console.log("downloadMovementReport called with params:", params);

  //     // Build the request body for download
  //     const requestBody = {
  //       reportType: "movement",
  //       filters: params
  //     };

  //     const response = await api.post("/reports/download", requestBody);

  //     console.log("Download Movement Report API Response:", response.data);

  //     return response.data;
  //   } catch (error) {
  //     console.error("Error downloading movement report:", error);
  //     throw error;
  //   }
  // },

  // Helper function to get default report data
  getDefaultReportData: (): MovementReportData => {
    return {
      message: "No data available",
      error: false,
      data: {
        content: [],
        links: [],
        page: {
          size: 10,
          totalElements: 0,
          totalPages: 0,
          number: 0,
        },
      },
    };
  },
};

export default ReportService;
